// extracted by mini-css-extract-plugin
module.exports = {"container":"DiscountDisclaimer_container__54Dmu","item":"DiscountDisclaimer_item__0_76Y"};